import { render, staticRenderFns } from "./AbkCvEducationsForm.vue?vue&type=template&id=b15057a8&scoped=true&"
import script from "./AbkCvEducationsForm.vue?vue&type=script&lang=js&"
export * from "./AbkCvEducationsForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkCvEducationsForm.vue?vue&type=style&index=0&id=b15057a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15057a8",
  null
  
)

export default component.exports